import { render, staticRenderFns } from "./ScoreBar.vue?vue&type=template&id=c64cc5b2&scoped=true"
import script from "./ScoreBar.vue?vue&type=script&lang=js"
export * from "./ScoreBar.vue?vue&type=script&lang=js"
import style0 from "./ScoreBar.vue?vue&type=style&index=0&id=c64cc5b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64cc5b2",
  null
  
)

export default component.exports